import { render, staticRenderFns } from "./StepPayUnderReview.vue?vue&type=template&id=23749fcc&scoped=true"
import script from "./StepPayUnderReview.vue?vue&type=script&lang=js"
export * from "./StepPayUnderReview.vue?vue&type=script&lang=js"
import style0 from "./StepPayUnderReview.vue?vue&type=style&index=0&id=23749fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23749fcc",
  null
  
)

export default component.exports